module.exports = {
          srcSet: __webpack_public_path__ + "public/images/17102bdd26577aca69356b6a5adae8b6-800.webp"+" 800w",
          images:[ {path: __webpack_public_path__ + "public/images/17102bdd26577aca69356b6a5adae8b6-800.webp",width: 800,height: 548}],
          src: __webpack_public_path__ + "public/images/17102bdd26577aca69356b6a5adae8b6-800.webp",
          toString:function(){return __webpack_public_path__ + "public/images/17102bdd26577aca69356b6a5adae8b6-800.webp"},
          
          width: 800,
          height: 548
        }